import React from 'react';

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	FormHelperText,
	Typography,
	Radio,
	RadioGroup as MuiRadioGroup,
} from '@mui/material';

import { applyLayoutStyles } from '@/components/DynamicForm/layout.styles.handler';
import { CollectionInput, LayoutType } from '@/components/DynamicForm/types/DynamicFormTypes';

const RadioGroup: React.FC<CollectionInput> = ({
	errMsg,
	name,
	label,
	value,
	onChange,
	onBlur,
	options = [],
	showError,
	layout,
	arrange,
}) => {
	// Deprecated — remove once we exclusively use layout.arrange.
	const extendedLayout = arrange && !(layout as LayoutType)?.arrange ? { arrange } : layout;

	return (
		<FormControl data-test-id={`${name}-radio`} error={showError}>
			<FormLabel>
				<Typography variant="header4">{label}</Typography>
			</FormLabel>
			<MuiRadioGroup sx={applyLayoutStyles({}, extendedLayout)}>
				{options.map(({ label: optLabel, value: optValue }, index) => (
					<FormControlLabel
						key={`${optValue}_${index}`}
						id={`${name}_${optValue}`}
						value={optValue}
						label={<Typography variant="bodyMediumBook">{optLabel}</Typography>}
						control={<Radio />}
						onChange={(e) => onChange?.(e)}
						onBlur={onBlur}
						checked={value === optValue}
						name={name}
					/>
				))}
			</MuiRadioGroup>
			{errMsg && showError && <FormHelperText>{errMsg}</FormHelperText>}
		</FormControl>
	);
};

export default RadioGroup;
